import { motion } from 'framer-motion'
import React from 'react'
import { CloseButton } from '../../../commons/buttons/CloseButton'
import { modalVariants } from 'utils/frame-motion-variants'

export const ElderlyCareScope = () => {
  return (
    <>
    <div className="flex justify-center items-center right-0 top-0 fixed z-30 w-full h-full backdrop-blur-sm bg-black/10">
            <motion.div className="m-1 max-w-2xl w-full relative bg-white rounded-lg shadow"
                variants={modalVariants}
                initial="initial"
                animate="animate"
                exit="exit"
            >
                <div className="absolute top-0 bottom-0 m-auto h-145 bg-white rounded-lg shadow px-4 py-5">
                    <div className="flex justify-center items-center rounded-t border-b pb-2">
                        <h3 className="text-lg font-semibold text-orange-600 uppercase">
                            Service Scope
                        </h3>
                        <CloseButton/>
                    </div>                    
                    <div className='text-gray-500 space-y-4 text-sm h-120 overflow-y-scroll'>                        
                        <div className='pt-2'>
                            <h4 className='uppercase font-bold'>
                                General Home Care
                            </h4>
                            <ul className='pl-4 list-disc py-2 space-y-2'>
                                <li>
                                    Provide nourishment, bathe, attend to toileting needs, change diapers, and attire.
                                </li>
                                <li>
                                    Offer assistance with mobility indoors and outdoors to minimize the risk of falls.
                                </li>
                                <li>
                                    Aid in home and outdoor exercise routines.
                                </li>
                                <li>
                                    Supervise medication intake schedules and dosages.
                                </li>
                                <li>
                                    Help with feeding.
                                </li>
                                <li>
                                    Accompany to medical appointments at clinics and hospitals.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
      </>
  )
}
